import homeView from './views/home';
import storyView from './views/story';
import artroomView from './views/artroom';
import travelView from './views/travel';
import productView from './views/product';
import allStoriesView from './views/all-stories';
import allProductsView from './views/all-products';
import allEventsView from './views/all-events';
import allExhibitionsView from './views/all-exhibitions';
import eventView from './views/event';
import artroomsView from './views/artrooms';
import travelsView from './views/travels';
import aboutView from './views/about';
import partnersView from './views/partners';
import faqView from './views/faq';
import subscribeView from './views/subscribe';
import loginView from './views/login';
import EmbedFormView from './views/embed-form';

export default [
	homeView,
	storyView,
	productView,
	allStoriesView,
	allProductsView,
	allEventsView,
	allExhibitionsView,
	eventView,
	artroomView,
	travelView,
	artroomsView,
	travelsView,
	aboutView,
	partnersView,
	faqView,
	subscribeView,
	loginView,
	EmbedFormView,
];
